import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FileSignature } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-banking/credit-line/agreement`;

export const CreditAgreementButton = ({ token, navigate }) => {
  const [state, setState] = useState(null);
  useEffect(() => {
    if (!token) return;
    axios.get(API, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setState(r.data.signed && !r.data.needs_resign ? 'signed' : 'sign'))
      .catch(() => setState('none'));
  }, [token]);
  const needsSign = state === 'sign';
  return (
    <button onClick={() => navigate('/pas/credit-agreement')} data-testid="credit-agreement-btn"
      className={`relative px-6 py-3 rounded-xl font-semibold flex items-center gap-2 transition-colors ${needsSign ? 'bg-amber-300 text-slate-900 hover:bg-amber-200' : 'bg-white/20 text-white hover:bg-white/30'}`}>
      <FileSignature className="w-5 h-5" /> Credit Agreement
      {needsSign && <span className="ml-1 text-[10px] uppercase tracking-wider bg-red-600 text-white px-2 py-0.5 rounded-full animate-pulse" data-testid="credit-agreement-sign-badge">Sign now</span>}
      {state === 'signed' && <span className="ml-1 text-[10px] uppercase tracking-wider bg-emerald-500/30 text-emerald-100 px-2 py-0.5 rounded-full" data-testid="credit-agreement-signed-badge">Signed</span>}
    </button>
  );
};
